module.exports = __webpack_public_path__ + "img/instagram.d0b7a2aa.svg";